export const ENTER_EXIT_TYPES_WITH_SEGMENT_RESTRICTION = [
  'ENTERS',
  'ENTERS_OR_IS_ALREADY_IN',
  'EXITS',
  'ENTER',
  'EXIT',
];

export function isEnterExitTypeWithSegmentRestriction(enterExitType) {
  return ENTER_EXIT_TYPES_WITH_SEGMENT_RESTRICTION.includes(enterExitType);
}

export function isRestrictedEvent(event) {
  if (!event) {
    return false;
  }

  if (event.isAllowed === false) {
    return true;
  }

  return !!(
    event.restricted ||
    event.restrictedEvent ||
    event.communication ||
    event.isCommunication ||
    event.special ||
    event.specialEvent ||
    event.isSpecial
  );
}

export function isEventDisabledForJourney(journey, event) {
  if (!journeyHasSelectedSegment(journey)) {
    return false;
  }

  return isRestrictedEvent(event);
}

export function journeyHasSelectedSegment(journey) {
  return journey?.segment != null;
}

export function segmentUsesRestrictedEvents(segment) {
  if (!segment) {
    return false;
  }

  return !!(
    segment.usesSpecialEvents ||
    segment.specialEventUsed ||
    segment.hasSpecialEvents ||
    segment.usesRestrictedEvents ||
    segment.restrictedEventUsed
  );
}

function normalizeAudienceSegmentList(segmentList) {
  if (segmentList == null) {
    return [];
  }
  return Array.isArray(segmentList) ? segmentList : [];
}

function isValidAudienceSegmentId(segment) {
  if (segment == null || segment === '') {
    return false;
  }

  if (typeof segment === 'object') {
    return segment.id != null && segment.id !== '';
  }

  return true;
}

function audienceHasValidSegmentIds(segmentList) {
  const list = normalizeAudienceSegmentList(segmentList);
  if (list.length === 0) {
    return false;
  }

  return list.some(isValidAudienceSegmentId);
}

export function communicationHasIncludedSegment(currentAudience) {
  return audienceHasValidSegmentIds(currentAudience?.segments);
}

export function communicationHasExcludedSegment(currentAudience) {
  return audienceHasValidSegmentIds(currentAudience?.ignoreSegments);
}

export function communicationIsPlainAllUsers(currentAudience) {
  return (
    !communicationHasIncludedSegment(currentAudience) &&
    !communicationHasExcludedSegment(currentAudience)
  );
}

// Filter trigger events whenever the audience is not plain All Users.
// Excluding segments is a targeted audience — not the same as All Users.
export function communicationHasSelectedSegment(currentAudience) {
  return !communicationIsPlainAllUsers(currentAudience);
}

export function isTriggerEventAllowed(event) {
  return event?.isAllowed !== false;
}
